import styled from "styled-components";
import {fonts, mediaSizes} from "ui/theme";
import {Tooltip} from "ui/base/tooltip/Tooltip";
import {DiscountList} from ".";

export const DiscountTooltip = ({discountList = [], place}) => (
    <Tooltip
        id="DiscountOffered"
        place={place}
        text={<DiscountList discountList={discountList}/>}
    >
        <DiscountLinkButton>Discount Offered</DiscountLinkButton>
    </Tooltip>
);

const DiscountLinkButton = styled.button`
    all: unset;
    cursor: pointer;
    font-family: Montserrat;
    font-size: ${fonts.sizes.small};
    font-weight: 600;
    text-align: left;
    text-decoration: underline;

    @media (width >= ${mediaSizes.lg}) {
        font-size: ${fonts.sizes.regular};
    }
`;
